export class UpdateCustomerEmail {
  idCustomer: number;
  newEmail: string;
}
